import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './huggg-id.module.scss';

const HugggID = (props) => {
  const { className, id } = props;

  return id ? (
    <div className={classnames(className, styles.id)} title={id}>
      {id}
    </div>
  ) : null;
};

HugggID.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};

export default HugggID;
